import _slicedToArray from "/codebuild/output/src145264479/src/LandingPage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import React, { useState } from 'react';
import { RemoveScroll } from 'react-remove-scroll';
import { useId, useWindowEvent, useFocusReturn } from '@mantine/hooks';
import { getDefaultZIndex, useComponentDefaultProps } from '@mantine/styles';
import { ModalBaseProvider } from './ModalBase.context.js';
import { ModalBaseCloseButton } from './ModalBaseCloseButton/ModalBaseCloseButton.js';
import { ModalBaseOverlay } from './ModalBaseOverlay/ModalBaseOverlay.js';
import { ModalBaseContent } from './ModalBaseContent/ModalBaseContent.js';
import { ModalBaseHeader } from './ModalBaseHeader/ModalBaseHeader.js';
import { ModalBaseTitle } from './ModalBaseTitle/ModalBaseTitle.js';
import { ModalBaseBody } from './ModalBaseBody/ModalBaseBody.js';
import { NativeScrollArea } from './NativeScrollArea/NativeScrollArea.js';
import { useLockScroll } from './use-lock-scroll.js';
import useStyles from './ModalBase.styles.js';
import { OptionalPortal } from '../Portal/OptionalPortal.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var ModalBaseDefaultProps = {
  closeOnClickOutside: true,
  withinPortal: true,
  lockScroll: true,
  trapFocus: true,
  returnFocus: true,
  closeOnEscape: true,
  keepMounted: false,
  zIndex: getDefaultZIndex("modal"),
  padding: "md",
  size: "md",
  shadow: "xl"
};
function ModalBase(props) {
  var _a = useComponentDefaultProps("ModalBase", ModalBaseDefaultProps, props),
    opened = _a.opened,
    onClose = _a.onClose,
    children = _a.children,
    closeOnClickOutside = _a.closeOnClickOutside,
    __staticSelector = _a.__staticSelector,
    transitionProps = _a.transitionProps,
    withinPortal = _a.withinPortal,
    portalProps = _a.portalProps,
    keepMounted = _a.keepMounted,
    target = _a.target,
    zIndex = _a.zIndex,
    lockScroll = _a.lockScroll,
    trapFocus = _a.trapFocus,
    closeOnEscape = _a.closeOnEscape,
    returnFocus = _a.returnFocus,
    padding = _a.padding,
    shadow = _a.shadow,
    id = _a.id,
    size = _a.size,
    variant = _a.variant,
    classNames = _a.classNames,
    unstyled = _a.unstyled,
    styles = _a.styles,
    className = _a.className,
    others = __objRest(_a, ["opened", "onClose", "children", "closeOnClickOutside", "__staticSelector", "transitionProps", "withinPortal", "portalProps", "keepMounted", "target", "zIndex", "lockScroll", "trapFocus", "closeOnEscape", "returnFocus", "padding", "shadow", "id", "size", "variant", "classNames", "unstyled", "styles", "className"]);
  var _useStyles = useStyles(null, {
      name: __staticSelector,
      classNames: classNames,
      styles: styles,
      unstyled: unstyled,
      variant: variant,
      size: size
    }),
    classes = _useStyles.classes,
    cx = _useStyles.cx;
  var _id = useId(id);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    titleMounted = _useState2[0],
    setTitleMounted = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    bodyMounted = _useState4[0],
    setBodyMounted = _useState4[1];
  var transitionDuration = typeof (transitionProps == null ? void 0 : transitionProps.duration) === "number" ? transitionProps == null ? void 0 : transitionProps.duration : 200;
  var shouldLockScroll = useLockScroll({
    opened: opened,
    transitionDuration: transitionDuration
  });
  useWindowEvent("keydown", function (event) {
    if (!trapFocus && event.key === "Escape" && closeOnEscape) {
      onClose();
    }
  });
  useFocusReturn({
    opened: opened,
    shouldReturnFocus: trapFocus && returnFocus
  });
  return /* @__PURE__ */React.createElement(OptionalPortal, __spreadValues({
    withinPortal: withinPortal,
    target: target
  }, portalProps), /* @__PURE__ */React.createElement(ModalBaseProvider, {
    value: {
      __staticSelector: __staticSelector,
      opened: opened,
      onClose: onClose,
      closeOnClickOutside: closeOnClickOutside,
      transitionProps: __spreadProps(__spreadValues({}, transitionProps), {
        duration: transitionDuration,
        keepMounted: keepMounted
      }),
      zIndex: zIndex,
      padding: padding,
      id: _id,
      getTitleId: function getTitleId() {
        return "".concat(_id, "-title");
      },
      getBodyId: function getBodyId() {
        return "".concat(_id, "-body");
      },
      titleMounted: titleMounted,
      bodyMounted: bodyMounted,
      setTitleMounted: setTitleMounted,
      setBodyMounted: setBodyMounted,
      trapFocus: trapFocus,
      closeOnEscape: closeOnEscape,
      shadow: shadow,
      stylesApi: {
        name: __staticSelector,
        size: size,
        variant: variant,
        classNames: classNames,
        styles: styles,
        unstyled: unstyled
      }
    }
  }, /* @__PURE__ */React.createElement(RemoveScroll, {
    enabled: shouldLockScroll && lockScroll
  }, /* @__PURE__ */React.createElement("div", __spreadValues({
    className: cx(classes.root, className)
  }, others), children))));
}
ModalBase.CloseButton = ModalBaseCloseButton;
ModalBase.Overlay = ModalBaseOverlay;
ModalBase.Content = ModalBaseContent;
ModalBase.Header = ModalBaseHeader;
ModalBase.Title = ModalBaseTitle;
ModalBase.Body = ModalBaseBody;
ModalBase.NativeScrollArea = NativeScrollArea;
export { ModalBase, ModalBaseDefaultProps };